



























import { Vue, Component } from 'vue-property-decorator'

@Component({ name: 'v-confirmation-modal' })
export default class ConfirmationModal extends Vue {}
